var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"peek"}},[(_vm.isloading)?_c('div',{staticClass:"loader"}):_c('div',{attrs:{"id":"email__message"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }